import { createStyles, makeStyles } from '@material-ui/styles';
import { Theme } from '../../styles';

export const useStyles = makeStyles((theme: Theme) => createStyles(({
  root: {
    border: `2px dashed ${theme.palette.background.b8}`,
    backgroundColor: theme.palette.background.b3,
    padding: '8px 12px',
    '&:disabled': {
      border: `2px dashed ${theme.palette.border.main}`,
      color: theme.palette.text.disabled,
    },
    '&:hover, &:focus': {
      backgroundColor: theme.palette.background.b4,
    },
    '&:active': {
      borderColor: theme.palette.action.active,
    },
  },
})));
